import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import QualDrawComponent from './js/qual-draw.component';

ComponentsFactory.getInstance().define('qual-draw', QualDrawComponent);
